import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/sources/edit/$id/$previewId')({
  beforeLoad: () => getTitleContextSlice('Preview'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
